<template>
  <div class="emd-menu__subsection menu-subitems">
    <ul class="emd-menu-list">
      <template v-for="(item, id) in subitems">
        <router-link
          v-if="item.showItem"
          :key="id"
          :to="{ name: id }"
          :class="{ _active: item.active }"
          tag="li"
          exact
          data-testid="dropdown-sub-menu"
          class="emd-menu-list__item"
        >
          <a
            class="menu-subitem"
            @click="sendEvent(item.label)"
          >
            {{ $t(item.label) }}
          </a>
        </router-link>
      </template>
    </ul>
  </div>
</template>

<script>
import Amplitude from '@/amplitude-events/sidemenu.amplitude'

export default {
  name: 'AppMenuSubitems',

  props: {
    subitems: {
      type: Object,
      required: true
    }
  },

  methods: {
    sendEvent (name) {
      const eventName = name.replace('sidemenu.submenu.', '')
      const [menu, submenu] = eventName.split('.')
      Amplitude.events[menu].buttonClicked({
        submenu: submenu.replace('-', ' ')
      })
    }
  }
}
</script>

<style scoped>
.menu-subitems {
  padding-left: 16px !important;
}
.menu-subitems:before {
  content: none !important;
}
.menu-subitem:hover {
  background-color: var(--gray-50-squanchy);
  border-radius: 8px;
  color: var(--color-black-1);
}
.emd-menu-list__item._active > .menu-subitem:hover {
  background-color: var(--gray-50-squanchy);
  border-radius: 8px;
}

@media only screen and (max-width: 768px) {
  .menu-subitems {
    position: initial;
    background-color: var(--color-white) !important;
  }

  .emd-menu-list__item._active > .menu-subitem:hover {
    background-color: var(--gray-50-squanchy);
    border-radius: 8px;
  }
}
</style>

<i18n>
  {
    "pt-BR": {
      "sidemenu": {
        "submenu": {
          "sales": {
            "payment-links": "Links de pagamento",
            "orders": "Pedidos",
            "charges": "Cobranças",
            "trf": "Histórico (TRF)",
            "chargebacks": "Contestações"
          },
          "recurrence": {
            "invoices": "Faturas",
            "plans": "Planos",
            "subscriptions": "Assinaturas"
          },
          "team": {
            "logs": "Logs",
            "invites": "Convites",
            "users": "Usuários"
          },
          "financial": {
            "settlements": "Liquidações",
            "balance": "Extrato",
            "transfers": "Transferências",
            "anticipations": "Antecipações",
            "earning-statements": "Informe de rendimentos"
          },
          "physical-world": {
            "terminals": "Maquininhas",
            "service-orders": "Ordens de Serviço"
          },
          "settings": {
            "fees": "Taxas e prazos",
            "account-settings": "Conta",
            "webhook-settings": "Webhooks",
            "order-settings": "Pedidos",
            "keys": "Chaves",
            "recurrence": "Recorrência",
            "functionalities": "Funcionalidades",
            "gateways": "Modelo de negócio",
            "payment-methods": "Meios de pagamento",
            "affiliations": "Afiliações"
          }
        }
      }
    },
    "en-US": {
      "sidemenu": {
        "submenu": {
          "sales": {
            "payment-links": "Payment links",
            "orders": "Orders",
            "charges": "Charges",
            "trf": "History (TRF)",
            "chargebacks": "Chargebacks"
          },
          "recurrence": {
            "invoices": "Invoices",
            "plans": "Plans",
            "subscriptions": "Subscriptions"
          },
          "team": {
            "logs": "Logs",
            "invites": "Invites",
            "users": "Users"
          },
          "financial": {
            "settlements": "Settlements",
            "balance": "Balance",
            "transfers": "Transfers",
            "anticipations": "Anticipations",
            "earning-statements": "Earning statements"
          },
          "physical-world": {
            "terminals": "Terminals",
            "service-orders": "Service Orders"
          },
          "settings": {
            "fees": "Fees and delays",
            "account-settings": "Account",
            "webhook-settings": "Webhooks",
            "order-settings": "Orders",
            "keys": "Keys",
            "recurrence": "Recurrence",
            "functionalities": "Functionalities",
            "gateways": "Gateways",
            "payment-methods": "Payment Methods",
            "affiliations": "Affiliations"
          }
        }
      }
    }
  }
</i18n>
